export default "__VITE_ASSET__6lgMUbK7__"